import * as React from 'react';
import {WrappedFieldProps} from 'redux-form';
import * as FleetModule from 'Modules/FleetModule';
import {withTranslation} from 'react-i18next';

type Props = {
    label: string;
    type: string;
    max?: number;
    min?: number;
    disabled: boolean;
    options: Array<FleetModule.Types.CarFleetSimpleDto>;
    t?: Function;
    onDelete: Function;
    showList: () => Function;
};

class FleetIdsSelect extends React.PureComponent<WrappedFieldProps & Props> {
    public handleClick(value) {
        // if (this.props.disabled) {
        //     return null;
        // } else {
        //     this.props.input.onChange(value);
        // }
    }

    public handleDelete(car: FleetModule.Types.CarFleetSimpleDto) {
        this.props.onDelete(car);
    }

    public render() {
        const {input, meta, label, disabled, t, showList} = this.props;
        return (
            <div className="assign mt-20 mb-20">
                <label htmlFor={input.name} className="form-field__label">{label}</label>
                <div className="assign__control">
                    <div className="assign-item__image-wrapper"/>
                    <div className="assign-item__title-1">
                        <span>{t('fleetName')}</span>
                    </div>
                    <div className="assign-item__title-2">
                        <span>{t('numberOfCars')}</span>
                    </div>
                    <div className="assign-item__delete"/>
                </div>
                {Array.isArray(input.value) && input.value.length > 0 &&
                <div className="form-field form-field--expand mt-10">
                    {input.value.map((element: FleetModule.Types.CarFleetSimpleDto, idx) => {
                        return (
                            <div
                                key={`${element}-${idx}`}
                                className="assign-item assign-item--border"
                                onClick={() => this.handleClick(element.id)}
                            >
                                <div className="assign-item__image-wrapper">
                                    <img src="/images/icons/fleet.svg" alt="" className="assign-item__img"
                                         width={25}/>
                                </div>
                                <div className="assign-item__title-1">{element.name}</div>
                                <div className="assign-item__title-2 flex--justify-center">
                                    {element.numberOfCars}
                                </div>
                                <div className="assign-item__delete">
                                    <i className="icon--plus_sign rotate-45deg"
                                       onClick={() => this.handleDelete(element)}/>
                                </div>
                            </div>
                        );
                    })
                    }
                </div>
                }
                {(meta.touched &&
                    (meta.error && (
                        <div className="form_field--error_wrapper">
                            <span className="form_field--error">{meta.error}</span>
                        </div>
                    ))) ||
                (meta.warning && <span>{meta.warning}</span>)}

                <p className="flex flex--center mt-10 font-xmd">
                    <span className="mr-7">{t('addFleet')}</span>
                    <i className="icon--plus_sign" onClick={showList}/>
                </p>
            </div>
        );
    }
}

export default withTranslation(['forms', 'errors', 'carDetails'])(FleetIdsSelect as React.ComponentType<any>) as React.ComponentClass<any>;



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/FleetIdsSelect.tsx